export default "__VITE_ASSET__a9798cff__"